/**
 * Dashboard campaign coach chat protocol and automatic action field constants.
 * Field labels mirror CoachAutomaticActionFieldLabels on the backend.
 */

export const SEGMENT_TYPE_MARKDOWN = 'markdown';
export const SEGMENT_TYPE_CHOICES = 'choices';
export const SEGMENT_TYPE_PHASE = 'phase';
export const SEGMENT_TYPE_AUTOMATIC_ACTION = 'automatic_action';
export const SEGMENT_TYPE_AUTOMATIC_ACTION_EVENT = 'automatic_action_event';

export const CHOICES_KIND_REPLY = 'reply';
export const CHOICES_KIND_ACTION = 'action';
export const CHOICES_KIND_AUTOMATIC_ACTION_CONFIRM = 'automatic_action_confirm';

export const AUTOMATIC_ACTION_CONFIRM = 'confirm_automatic_action';
export const AUTOMATIC_ACTION_CANCEL = 'cancel_automatic_action';

export const PHASE1_ACTION_IDS = Object.freeze([
  'post_campaign_update',
  'connect_instagram',
  'set_fundraising_goal',
  'improve_description',
  'add_or_update_tags',
]);

export const PHASE1_ACTION_ID_SET = new Set(PHASE1_ACTION_IDS);

const ISSUE_TAGS_HINT =
  "This becomes your campaign's full Issues list. Include issues you want to keep plus any new ones. " +
  'Separate names with commas (max 10). Example: Health Care, Environment, Civil Rights. ' +
  'If you do not want to change issues, tap Cancel.';

export const AUTOMATIC_ACTION_FIELD_DEFINITIONS = Object.freeze({
  post_campaign_update: [
    { key: 'name', label: 'Title', type: 'text' },
    { key: 'description', label: 'Description', type: 'textarea' },
  ],
  connect_instagram: [{ key: 'instagram', label: 'Campaign Instagram Page', type: 'text' }],
  set_fundraising_goal: [{ key: 'fundraising_goal', label: 'Fundraising Goal', type: 'number' }],
  improve_description: [{ key: 'description', label: 'Your Story', type: 'textarea' }],
  add_or_update_tags: [
    {
      key: 'tags',
      label: 'Issues',
      type: 'text',
      placeholder: 'Comma-separated issue names (max 10)',
      hint: ISSUE_TAGS_HINT,
    },
  ],
});

export const AUTOMATIC_ACTION_SUMMARY_LABELS = Object.freeze({
  updateTitle: 'Title',
  fundraisingGoal: 'Fundraising Goal',
  instagram: 'Campaign Instagram Page',
  issues: 'Issues',
});

export const AUTOMATIC_ACTION_CURRENT_VALUE_LABEL = 'Current';

export const CLIENT_PLATFORM_WEB = 'web';
